/* eslint-disable react/prop-types */
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import React from "react";

function NewTable({ columns, rows, align, isSubscription, tableBodyTheme }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table" stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell
                key={col.displayName}
                align={align}
                rowSpan={col.rowspan ? col.rowSpan : 1}
                colSpan={col.colSpan ? col.colSpan : 1}
                sx={{
                  color: "white",
                  padding: "10px",
                  textAlign: "left",
                  fontSize: "12px",
                  fontWeight: "600",
                  background:
                    "linear-gradient(180deg, #2A93C1 0%, #1D7196 87.50%, #BCD4DE 100%)",
                }}
              >
                {col.displayName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody
          sx={{
            "& .MuiTableCell-root": {
              padding: "16px 10px",
            },
            "& .MuiTypography-root": {
              fontSize: "12px",
              color: "#000000",
            },
            "tr:nth-child(even)": {
              backgroundColor: !isSubscription
                ? { backgroundColor: tableBodyTheme }
                : "#E8F6FC",
            },
          }}
        >
          {rows}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default NewTable;
